import { render, staticRenderFns } from "./SideBarNewInvoice.vue?vue&type=template&id=07c8e7f9"
import script from "./SideBarNewInvoice.vue?vue&type=script&lang=js"
export * from "./SideBarNewInvoice.vue?vue&type=script&lang=js"
import style0 from "./SideBarNewInvoice.vue?vue&type=style&index=0&id=07c8e7f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports